import axios from "axios";
import { handleRuntimeAccessError } from "./runtimeAccess";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const PARENT_API = `${BACKEND}/api`;

// Parent session is carried by the httpOnly `parent_access_token` cookie — a distinct
// cookie name from staff/student so all three sessions can coexist in one browser.
const papi = axios.create({ baseURL: PARENT_API, withCredentials: true });

// MOB-SESSION web parity: the parent realm now has POST /parent/auth/refresh (cookie-carried), so a
// 12h access-token expiry mid-visit renews transparently instead of bouncing the guardian to login.
// Single-flight (parallel 401s share one refresh), one retry per request, and the auth endpoints
// themselves are excluded so a failed login/claim can never loop through here.
let refreshInFlight = null;
const AUTH_ENDPOINTS = /\/parent\/auth\/(login|claim|refresh|logout|reset)/;

papi.interceptors.response.use(
  (response) => response,
  async (error) => {
    handleRuntimeAccessError(error);
    const cfg = error?.config;
    if (error?.response?.status === 401 && cfg && !cfg._sessionRetried
        && !AUTH_ENDPOINTS.test(cfg.url || "")) {
      cfg._sessionRetried = true;
      try {
        if (!refreshInFlight) {
          refreshInFlight = papi.post("/parent/auth/refresh")
            .finally(() => { refreshInFlight = null; });
        }
        await refreshInFlight;
        return await papi.request(cfg);
      } catch (e) { /* refresh failed — the original 401 stays authoritative */ }
    }
    return Promise.reject(error);
  }
);

export default papi;
